import { useDeprecatedChatChannelStore } from "@src/appV2/Chat/useDeprecatedChatChannelStore";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { FEATURE_FLAG_DEFAULT_VALUES } from "@src/appV2/FeatureFlags/constants";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

interface UseIsUserInClipboardGuidesChannelParams {
  workplaceId: string;
}

export function useIsUserInClipboardGuidesChannel(
  params: UseIsUserInClipboardGuidesChannelParams
): boolean {
  const { workplaceId } = params;

  const config = useCbhFlag(CbhFeatureFlag.ALCHEMY_CLIPBOARD_GUIDES_EXPERIMENT, {
    defaultValue: FEATURE_FLAG_DEFAULT_VALUES[CbhFeatureFlag.ALCHEMY_CLIPBOARD_GUIDES_EXPERIMENT],
  });

  const { channels } = useDeprecatedChatChannelStore();

  if (!config.enabled) {
    return false;
  }

  if (channels.length === 0) {
    return false;
  }

  const channelUrl = `${workplaceId}_${config.channelUrlSuffix}`;

  return channels.some((channel) => channel.url === channelUrl);
}
